import { render, staticRenderFns } from "./brands.vue?vue&type=template&id=752900bd&scoped=true"
import script from "./brands.vue?vue&type=script&lang=js"
export * from "./brands.vue?vue&type=script&lang=js"
import style0 from "./brands.vue?vue&type=style&index=0&id=752900bd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752900bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('752900bd')) {
      api.createRecord('752900bd', component.options)
    } else {
      api.reload('752900bd', component.options)
    }
    module.hot.accept("./brands.vue?vue&type=template&id=752900bd&scoped=true", function () {
      api.rerender('752900bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/sections/brands.vue"
export default component.exports